import styles from "./IndustryInsightsCard.module.scss";

export default function IndustryInsightsCardWithDesc({ source, alt, title }) {
  return (
    <div className={styles.container}>
      <img src={source?.data?.[0]?.attributes?.url} alt={alt || ''} />
      <p>{title}</p>
    </div>
  );
}
